// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/about`
  | `/admin/backup`
  | `/admin/competitions`
  | `/admin/competitions/:id`
  | `/admin/competitions/add`
  | `/admin/forum_groups`
  | `/admin/forum_groups/:id`
  | `/admin/forum_groups/add`
  | `/admin/forums`
  | `/admin/forums/:id`
  | `/admin/forums/:id/rights`
  | `/admin/forums/add`
  | `/admin/imports/users`
  | `/admin/roles`
  | `/admin/roles/:id`
  | `/admin/roles/add`
  | `/admin/skills`
  | `/admin/skills/:id`
  | `/admin/skills/add`
  | `/admin/users`
  | `/admin/users/:id`
  | `/admin/users/add`
  | `/forums`
  | `/forums/:forum_id`
  | `/forums/:forum_id/post`
  | `/forums/:forum_id/topics/:id`
  | `/forums/:forum_id/topics/:id/edit`
  | `/login`
  | `/logout`
  | `/noaccount`
  | `/profile`
  | `/whoiswho`

export type Params = {
  '/admin/competitions/:id': { id: string }
  '/admin/forum_groups/:id': { id: string }
  '/admin/forums/:id': { id: string }
  '/admin/forums/:id/rights': { id: string }
  '/admin/roles/:id': { id: string }
  '/admin/skills/:id': { id: string }
  '/admin/users/:id': { id: string }
  '/forums/:forum_id': { forum_id: string }
  '/forums/:forum_id/post': { forum_id: string }
  '/forums/:forum_id/topics/:id': { forum_id: string; id: string }
  '/forums/:forum_id/topics/:id/edit': { forum_id: string; id: string }
}

export type ModalPath = `/charte-utilisation` | `/politique-confidentialite`

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
